import Typography from '@components/_atoms/Typography';
import DefaultLayout from '@components/_templates/DefaultLayout';
import { TypoVariant } from '@constants/atoms';
import styled from '@emotion/styled';
import { useIsMobile, useIsTablet } from '@hooks/responsive/useIsMobile';
import { white } from '@styles/Colors';
import { useTranslation } from 'next-i18next';

const CareerContainer = styled.div`
  padding-bottom: 100px;
`;

const SloganWrapper = styled.div`
  background-image: url('/assets/images/career-slogan.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-size: cover;
  height: 500px;
`;

const CareerTextWrapper = styled.div`
  display: grid;
  row-gap: 40px;
  text-align: center;
`;

type Props = {
  readonly title?: string;
  readonly children: React.ReactNode;
};

export default function CareerDefaultLayout({ title = "Let's grow together", children }: Props) {
  const isTablet = useIsTablet();
  const isMobile = useIsMobile();
  const { t } = useTranslation('document');

  return (
    <>
      <DefaultLayout isTransparent={true}>
        <CareerContainer>
          <SloganWrapper>
            <CareerTextWrapper>
              <Typography variant={isMobile ? TypoVariant.H3 : TypoVariant.H1} color={white}>
                {title}
              </Typography>
              <Typography variant={isMobile ? TypoVariant.MH2 : TypoVariant.MH1} color={white}>
                스틸 시장의 새로운 길을 개척하고 있는 우리의 열정있는 동료를 찾습니다
              </Typography>
            </CareerTextWrapper>
          </SloganWrapper>

          {children}
        </CareerContainer>
      </DefaultLayout>
    </>
  );
}
